import React from "react";
import { ArrowForward } from "@mui/icons-material";
import { Button } from "@platform/design-system";
import { RFP_ACTION_VALUES } from "@platform/rfp-core";

import { useRfpContext } from "../../RFP/contexts";
import { getFilteredCoverages } from "../../RFP/utils";

const { COVERAGE_INDEX } = RFP_ACTION_VALUES;
interface Props {
  name: string;
  handleNext: VoidFunction;
  isDisabled?: boolean;
}

// getFilteredCoverages lives in an untyped .js module; narrow its result
// through a guard instead of trusting the inferred type.
const hasCoverages = (
  value: unknown,
): value is { coverages: { isValid: boolean }[] } =>
  typeof value === "object" &&
  value !== null &&
  "coverages" in value &&
  Array.isArray(value.coverages);

const NextButton = ({
  name,
  handleNext,
  isDisabled,
}: Props): React.JSX.Element => {
  const { rfp } = useRfpContext();
  const filteredCoverages: unknown = getFilteredCoverages(rfp);
  const coverages = hasCoverages(filteredCoverages)
    ? filteredCoverages.coverages
    : [];
  const currentCoverageIndex = rfp[COVERAGE_INDEX] as number;
  const currentCoverage = coverages[currentCoverageIndex];

  return (
    <Button
      endIcon={<ArrowForward />}
      variant="secondary"
      disabled={
        isDisabled === undefined ? !currentCoverage.isValid : isDisabled
      }
      onClick={handleNext}
    >
      NEXT: {name}
    </Button>
  );
};
export default NextButton;
